import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import { Formik, Field, FieldArray, Form } from 'formik';
import StepperHorizontal from 'components/StepperHorizontal';
import * as Yup from 'yup';


export default class Wizard extends React.Component {

    static Page = ({ children, parentState }) => {
        return children(parentState);
    };

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            values: props.initialValues,
        };
    }

    next = values => {
        this.setState(state => ({
            page: Math.min(state.page + 1, this.props.children.length - 1),
            values
        }));
        window.scrollTo(0,0);
    };

    previous = () => {
        this.setState(state => ({
            page: Math.max(state.page - 1, 0)
        }));
        window.scrollTo(0,0);
    };

    handleSubmit = (values, bag) => {
        const { children, onSubmit } = this.props;
        const { page } = this.state;
        const isLastPage = page === React.Children.count(children) - 1;
        if (isLastPage) {
            return onSubmit(values, bag);
        } else {
            this.next(values);
            bag.setSubmitting(false);
        }
    };


    render() {



        const Page1Schema = Yup.object().shape({
            email: Yup.string().required('This value is required.').email('This value should be a valid email.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            name: Yup.string().required('This value is required.'),
            dba: Yup.string().required('This value is required.'),
            primary_jobtitle: Yup.string().required('This value is required.'),
            phone: Yup.string().required('This value is required.'),
            //country: Yup.string().required('This value is required.'),
            //address: Yup.string().required('This value is required.'),
            //city: Yup.string().required('This value is required.'),
            //state: Yup.string().required('This value is required.'),
            //postal: Yup.string().required('This value is required.').matches(/^[a-zA-Z0-9]*$/, 'This value should be alphanumeric characters only'),
            domain: Yup.string().required('This value is required.').url('This value should be a valid url.'),
            years_in_business: Yup.string().required('This value is required.'),
            coverage_range: Yup.string().required('This value is required.'),
            coverage_segments: Yup.string().required('This value is required.'),
            services_offered: Yup.string().required('This value is required.'),
            number_of_employees: Yup.string().required('This value is required.'),
            primary_distributor: Yup.string().required('This value is required.'),
        });


        const Page2Schema = Yup.object().shape({
            terms_agreement: Yup.mixed().oneOf([true], "Please verify that you've read the document above."),
        });

        const Page3Schema = Yup.object().shape({
            prices_agreement: Yup.mixed().oneOf([true], "Please verify that you've read the document above."),
        });

       // const Page4Schema = Yup.object().shape({
       //     document_uuid: Yup.string().required('This value is required.')
       // });
        const Page4Schema = Yup.object().shape({
        });


        const schemaArray = [Page1Schema, Page2Schema, Page3Schema, Page4Schema];

        const { children } = this.props;
        //console.log('children', this.props.children);
        const { page, values } = this.state;
        const activePage = React.Children.toArray(children)[page];
        //console.log('active page', this.state.page);
        const isLastPage = page === React.Children.count(children) - 1;

        const steps = [
            {
                title: 'Step 1',
                secondaryTitle:'Sign-up info',
                onClick: (e) => {
                    e.preventDefault();
                    this.setState({page: 0});
                }
            },
            {
                title: 'Step 2',
                secondaryTitle:'Key Points',
                onClick: (e) => {
                    e.preventDefault();
                    this.setState({page: 1});
                }
            },
            {
                title: 'Step 3',
                secondaryTitle: 'Unilateral Pricing Policy',
                onClick: (e) => {
                    e.preventDefault();
                    this.setState({page: 2});
                }
            },
           // {
           //     title: 'Step 4',
           //     secondaryTitle:'Reseller Agreement',
           //     onClick: (e) => {
           //         e.preventDefault();
           //         this.setState({page: 3});
           //     }
           // },
            {
                title: 'Step 4',
                secondaryTitle:'Get Approved',
                onClick: (e) => {
                    e.preventDefault();
                    this.setState({page: 4});
                }
            },
        ];


        return (
            <div className='whiteBox--form'>
                <div className='whiteBox--form-header'>
                    <h2 className='signUp-home-title'>Become a NOON Pro Today</h2>
                    <div className='stepper-component-style'>
                        <StepperHorizontal steps={steps} activeStep={this.state.page}/>
                    </div>
                    <h1>NOON Authorized Reseller</h1>
                    <p>As a NOON Authorized Reseller, you will have access to special pricing via our distributor channel and have a dedicated customer success manager to that will provide you with VIP support.
                        You'll also get extended warranty terms, and access to NOON sales and marketing materials.
                    </p>
                    <hr className='form-divider'/>
                </div>

                <div className='white-f-form'>

                <Formik
                    initialValues={values}
                    onSubmit={this.handleSubmit}
                    enableReinitialize={false}
                    validationSchema={schemaArray[page]}
                    render={props => (
                        <form className='my-f-form' onSubmit={props.handleSubmit}>
                            {React.cloneElement(activePage, {parentState: { ...props } })}
                            <div>
                                {page > 0 && (
                                    <button className='form-f-button-prev' type="button" onClick={this.previous}>
                                        Previous
                                    </button>
                                )}

                               {page > 0 && !isLastPage &&
                                    <button  className='form-f-button' type="submit">Next</button>
                               }
                                {isLastPage && (
                                    <button className='form-f-button' type="submit" disabled={props.isSubmitting}>
                                        Submit Application
                                    </button>
                                )}
                            </div>

                        </form>
                    )}
                />
               </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/routes/UserSignupHome/Wizard.js